import Lokka from 'lokka';
import LokkaTransportHttp from 'lokka-transport-http';

var Graphql = {};

Graphql.setup = function () {
  Graphql.Lokka = new Lokka({
    transport: new LokkaTransportHttp('/graphql', {
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      }
    })
  });
};

Graphql.queryWithOperationName = function (operationName, vars) {
  if (!operationName) {
    throw new Error('operationName is required!');
  }

  return this.Lokka._transport.send(null, vars, operationName);
};

export default Graphql;
